export const maintenance = false;
export const DEFAULT_LANGUAGE = 'en';
// export const API_BASE_URL = 'https://devapi.focusly.pro';
// export const IMAGE_BASE_URL = 'https://devapi.focusly.pro/media/';


export const API_BASE_URL = 'https://focusly-api.shadhin.ai';
export const IMAGE_BASE_URL = 'https://focusly-api.shadhin.ai/media/';
export const Premium = false;
